import * as React from "react";
import TreeSelect from "rc-tree-select";
import Button from "../core/Button";
import { toast } from "../../utils";
import { updateResource, updateResourceCategory } from "../../libs/resources";
import styled from "styled-components";

interface Props {
  categories: IResourceTreeElement[];
  currentCategory?: IResourceCategory;
  currentResource?: IResource;
}

interface State {
  selectedValue: string;
  treeData: IResourceTreeElement[];
  tsOpen: boolean;
  isLoading: boolean;
}

interface IResourceTreeElement {
  key: string;
  value: string;
  parentId?: number | null;
  title: string;
  children?: IResourceTreeElement[];
}

const DescriptionContainer = styled.div`
  min-height: 200px;
  font-size: 18px;
  display: flex;
  justify-content: center;
  border-right: 1px solid #e5e5e5;
`;

const SubmitContainer = styled.div`
  height: 80px;
  max-width: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

class MoveResourceCategory extends React.Component<Props, State> {
  state: State = {
    selectedValue: undefined,
    treeData: undefined,
    tsOpen: false,
    isLoading: false,
  };

  UNSAFE_componentWillMount(): void {
    this.setTreeData();
  }

  setTreeData = () => {
    const { currentCategory, currentResource, categories } = this.props;
    let treeDataModify: IResourceTreeElement[] = [];
    if (currentCategory) {
      treeDataModify = [
        {
          key: "0",
          title: "Root",
          value: "0",
          children: categories,
        },
      ];
    }
    if (currentResource) {
      treeDataModify = categories;
    }
    this.setState({ treeData: treeDataModify });
  };

  handleUpdate = async () => {
    const { selectedValue } = this.state;
    const { currentCategory, currentResource } = this.props;

    // Convert parent ID to number
    let parentId;
    try {
      parentId = Number(selectedValue);
    } catch (e) {
      toast.error("Invalid parent folder selected");
      throw e;
    }

    // Only update if its a number
    if (!isNaN(parentId)) {
      this.setState({ isLoading: true });

      // Backend call to update
      let resp;
      try {
        if (currentCategory) {
          const resourceCat: IResourceCategory = {
            parent_id: parentId === 0 ? null : parentId,
          };
          resp = await updateResourceCategory(currentCategory.id, resourceCat);
        }
        if (currentResource && parentId !== 0) {
          const resource: IResource = {
            resource_category_id: parentId,
          };
          resp = await updateResource(currentResource.id, resource);
        }
      } catch (e) {
        toast.error(`Move failed: ${e}`);
        throw e;
      }

      // Check response from backend call
      if (resp && resp.status === "success") {
        toast.success("Move completed");
        if (currentCategory) {
          location.assign(`/resource_categories/${currentCategory.id}`);
        }
        if (currentResource) {
          location.assign(`/resources/${currentResource.id}`);
        }
      } else {
        toast.error("Move failed");
      }
      this.setState({ isLoading: false });
    }
  };

  render() {
    const { selectedValue, treeData, tsOpen, isLoading } = this.state;

    const treeComponent = (
      <TreeSelect
        style={{ width: 400 }}
        transitionName="rc-tree-select-dropdown-slide-up"
        choiceTransitionName="rc-tree-select-selection__choice-zoom"
        dropdownStyle={{ maxHeight: 700, overflow: "auto" }}
        placeholder={<i>Select Category</i>}
        allowClear
        treeLine
        value={selectedValue}
        treeData={treeData}
        treeNodeFilterProp="title"
        treeDefaultExpandAll
        open={tsOpen}
        onChange={val => {
          this.setState({ selectedValue: val, tsOpen: false });
        }}
        onDropdownVisibleChange={v => {
          this.setState({
            tsOpen: v,
          });
          return true;
        }}
      />
    );

    const submitButton = (
      <SubmitContainer>
        <Button
          onClick={this.handleUpdate}
          disabled={isLoading}
          loading={isLoading}
          color="primary"
        >
          Move
        </Button>
      </SubmitContainer>
    );

    const description = (
      <DescriptionContainer>
        {selectedValue ? "Destination selected: " : "Select destination folder"}
      </DescriptionContainer>
    );

    return (
      <div className={"columns"}>
        <div className="column is-one-quarter">{description}</div>
        <div className="column">
          {treeComponent}
          {selectedValue && submitButton}
        </div>
      </div>
    );
  }
}

export default MoveResourceCategory;



// WEBPACK FOOTER //
// ./app/javascript/components/resources/MoveResourceCategory.tsx